var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSqiggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1148 220",
    style: {
      enableBackground: "new 0 0 1148 220"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:none;stroke:url(#SVGID_4_);stroke-width:45.3171;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:url(#SVGID_5_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.2704,
    y1: 110.0457,
    x2: 1129.6586,
    y2: 110.0457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001260747,
    style: {
      stopColor: "#00D4D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9977,
    style: {
      stopColor: "#00AA06"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_1_)",
      strokeWidth: 45.3171,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 1107,41.3 1030.7,178.8 954.5,41.3 878.2,178.8 801.9,41.3 725.6,178.8 649.4,41.3 573,178.8 496.6,41.3 420.3,178.8 344.1,41.3  267.7,178.8 191.4,41.3 115.2,178.8 38.9,41.3 "
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqiggle);
export default __webpack_public_path__ + "static/media/sqiggle.e1d334dfae884f5f8b0ca20f105b5461.svg";
export { ForwardRef as ReactComponent };